// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-collateral-app-v2/lib/Utility/Collateral/App/Service/User';

export const useAcceptCollateralAgreementRequest = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_AcceptCollateralAgreementRequest,
    'Accepted collateral agreement request',
    'Failed to accept collateral agreement',
  );
  return submit;
};
